// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"798":"31edf351","916":"0ebf039b"}[chunkId] + ".js";
};